(function () {
  "use strict";
  if (window.__pineconeOpenAIPixelInstalled) return;
  window.__pineconeOpenAIPixelInstalled = true;
  var initialized = false;
  var pageMeasured = false;
  var attempts = 0;
  var pixelId = "D2q6EpLCJBCuEXtiWYaxFD";
  var debug = new URLSearchParams(window.location.search).get("pc_oai_debug") === "1";

  function report(message) {
    if (debug && window.console) window.console.info("[Pine Cone OpenAI] " + message);
  }

  report("Integration loaded");

  function ensurePixel() {
    if (initialized) return;
    if (!window.oaiq) {
      var queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
    }
    window.oaiq("consent", false);
    window.oaiq("init", { pixelId: pixelId, debug: debug });
    initialized = true;
    report("Pixel initialized");
    if (!document.querySelector('script[src="https://bzrcdn.openai.com/sdk/oaiq.min.js"]')) {
      var script = document.createElement("script");
      script.async = true;
      script.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
      document.head.appendChild(script);
    }
  }

  function syncConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = false;
    if (privacy && typeof privacy.marketingAllowed === "function" && typeof privacy.analyticsProcessingAllowed === "function") {
      try {
        allowed = privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true;
      } catch (error) {
        allowed = false;
      }
    }
    report("Measurement allowed: " + allowed);
    if (!allowed) {
      if (initialized) window.oaiq("consent", false);
      return;
    }
    ensurePixel();
    window.oaiq("consent", true);
    if (!pageMeasured) {
      pageMeasured = true;
      window.oaiq("measureSingle", pixelId, "page_viewed", { type: "contents" }, { opt_out: true });
      report("Page view queued");
    }
  }

  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      syncConsent();
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.2" }], function (error) {
        if (!error) syncConsent();
        else report("Privacy API could not load");
      });
      return;
    }
    if (attempts++ < 50) window.setTimeout(loadPrivacy, 100);
  }

  document.addEventListener("visitorConsentCollected", syncConsent);
  loadPrivacy();
})();
